export default function configureHoneybadger() {
  let environment = "production";
  if (typeof window !== "undefined") {
    if (window.location.host.indexOf("localhost") >= 0) {
      environment = "development";
    }

    if (window.location.host.indexOf("--") >= 0) {
      environment = "test";
    }
  }

  return {
    api_key: "8da126ad",
    environment,
    developmentEnvironments: ["development", "test"],
  };
}
